import useSWR, { SWRResponse } from 'swr';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '@/firebase/firebase';
import { IAnalytic } from '@/types/Collections/analytics';

const fetcher = async (): Promise<IAnalytic | null> => {
  const docRef = doc(db, 'analytics/trending');
  return getDoc(docRef)
    .then(doc => {
      if (doc.exists()) {
        const data = doc.data() as IAnalytic;
        return data;
      }
      return null;
    })
    .catch(() => null);
};

const useTrendingTopics = (): SWRResponse<IAnalytic | null> => {
  return useSWR('analytics/trending', () => fetcher());
};

export default useTrendingTopics;
